import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import Store from '@ember-data/store';
import FundsService from 'donor-elf-web/services/funds-service';
import { tracked } from '@glimmer/tracking';

export default class AssignedTasksDashboardComponent extends Component {
  @service declare fundsService: FundsService;
  @service declare store: Store;

  @tracked dueCount = '--';
  @tracked totalCount = '--';
  @tracked reviewItemsCount = 0;
  @tracked campaignTransactionsToApproveCount = 0;

  templateDidInsert = () => {
    this.load();
  };

  @action
  async load() {
    let dashboard = await this.store.findRecord(
      'assign-tasks/dashboard',
      this.fundsService.selectedFund!.id,
    );
    if (!this.isDestroyed) {
      this.dueCount = dashboard.dueCount.toString();
      this.totalCount = dashboard.totalCount.toString();
      this.reviewItemsCount = dashboard.reviewItemsCount;
      this.campaignTransactionsToApproveCount =
        dashboard.campaignTransactionsToApproveCount;
    }
  }
}
